// export { default as pay} from './pay';
// export { default as payment} from './payment';
// export { default as review_and_submit} from './review_and_submit';
// export { default as shipping} from './shipping';
// export { default as shirt} from './shirt';


import { combineReducers } from 'redux';

import form from './form';
import shirt from "./shirt";
import payment from "./payment";
import shipping from "./shipping";


export default combineReducers({
    form,
    shirt,
    payment,
    shipping
})


